module.exports = __webpack_public_path__ + "static/media/close-icon-dark.be098e8f.svg";